<template>
  <div class="u-16">
    <el-form
      :model="refundSplitForm"
      ref="refundSplitForm"
      class="u-16 grid refundForm"
    >
      <table class="refundtable u-16">
        <thead>
          <tr valign="middle">
            <th width="28">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              ></el-checkbox>
            </th>
            <th width="290">Терминал контрагента</th>
            <th>Назначение</th>
            <th width="180">Сумма</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in refundSplitForm.splitList" :key="index">
            <!-- checkbox -->
            <td>
              <el-form-item label-width="0">
                <el-checkbox
                  v-model="item.selected"
                  :value="item.id"
                  @change="handleCheckedSplitChange($event, item)"
                />
              </el-form-item>
            </td>

            <!-- split_terminal  -->
            <td>{{ terminalName(item.split_terminal_id) }}</td>

            <!-- purpose -->
            <td>{{ item.purpose }}</td>

            <!-- amount -->
            <td>
              <el-form-item label-width="0">
                <div class="el-input el-input--small">
                  <money
                    class="el-input__inner text-center"
                    v-bind="money"
                    v-model="item.amount"
                    @input="setSplitInfo"
                  ></money>
                </div>
              </el-form-item>
            </td>
          </tr>
        </tbody>
      </table>
    </el-form>
    <hr class="ver-margin-5" />
  </div>
</template>

<script>
import Vuex from "vuex";
import { mapGetters } from "vuex";
import { _ } from "vue-underscore";
import { Money } from "v-money";

export default {
  name: "refundSplitTable",
  props: {
    splitList: Array,
    currency: String
  },
  data() {
    return {
      checkAll: true,
      isIndeterminate: false,
      refundSplitForm: {
        splitList: []
      },
      amount: 0,
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: " " + this.currency,
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    ...mapGetters(["terminalName", "currencyCharacter"])
  },
  methods: {
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.refundSplitForm.splitList.forEach(el => {
        el.selected = val;
      });
      this.setSplitInfo();
    },
    handleCheckedSplitChange() {
      let length = this.refundSplitForm.splitList.length;
      let count = this.refundSplitForm.splitList.filter(el => el.selected)
        .length;
      this.checkAll = count === length;
      this.isIndeterminate = count > 0 && count < length;
      this.setSplitInfo();
    },
    calcTotalAmount() {
      let list = this.refundSplitForm.splitList
        .filter(el => el.selected)
        .map(({ amount, split_terminal_id, purpose, fee }) => ({
          amount: Math.round(amount * 100),
          split_terminal_id,
          purpose,
          fee
        }));
      let amount = 0;
      for (let i = 0; i < list.length; i++) {
        amount = amount + list[i]["amount"];
      }
      return { list, amount };
    },
    setSplitInfo() {
      this.$emit("updateSplitTotal", this.calcTotalAmount());
    }
  },
  mounted() {
    if (this.splitList) {
      this.refundSplitForm.splitList = this.splitList.map(
        ({ id, split_terminal_id, amount, fee, currency_code, purpose, source_terminal_id }) => ({
          id,
          split_terminal_id,
          amount: parseFloat(amount / 100),
          fee,
          currency_code,
          purpose,
          selected: true,
          source_terminal_id
        })
      );
    }
    this.setSplitInfo();
  },
  components: {
    Money
  }
};
</script>
